<script setup lang="ts">
import type { NoticesCollectionItemProps } from '@/components/items/NoticesMenuCardCollectionItem.vue';

import { inject } from 'vue';

import { emptyAsyncFunc } from '@/utils/funcs';
import NoticesMenuCardCollectionItem from '@/components/items/NoticesMenuCardCollectionItem.vue';
import {
  noticesOpenItemKey,
  noticesToggleItemReadKey,
} from '@/constants/injectionKeys';

export interface Props {
  items?: NoticesCollectionItemProps[];
  loadingIds?: number[];
}
const props = withDefaults(defineProps<Props>(), {
  items: () => [],
  loadingIds: () => [],
});

// TODO VS Code's Vue linter warnings in <template>
const openItem = inject(noticesOpenItemKey, emptyAsyncFunc) as
  | undefined
  | ((id?: number) => void);
const toggleItemRead = inject(noticesToggleItemReadKey, emptyAsyncFunc) as
  | undefined
  | ((id?: number) => void);
</script>

<template>
  <div
    :class="$style.noticesMenuCardCollection"
    data-testid="noticesMenuCardCollection"
  >
    <NoticesMenuCardCollectionItem
      v-for="item in props.items"
      :key="item.id"
      v-bind="item"
      :class="$style.item"
      :is-loading="!!item.id && loadingIds.indexOf(item.id) >= 0"
      @item-click="openItem"
      @icon-click="toggleItemRead"
    />
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.noticesMenuCardCollection {
}
  .item + .item {
    border-top: 1px solid colors.$color-brand-100;
  }
</style>
